import OptimiserStatusApi from 'api/optimiserStatus';
import { SOLACE_HEALTH as actionType } from './actionTypes';

const toPlain = data => (data && typeof data.toJS === 'function' ? data.toJS() : data);

const loadInFlight = () => ({ type: actionType.LOAD_IN_FLIGHT });
const loadSuccess = data => ({ type: actionType.LOAD_SUCCESS, data });
const loadFailure = error => ({ type: actionType.LOAD_FAILURE, error });

export const loadBrokerHealth = () => (dispatch) => {
  dispatch(loadInFlight());
  return OptimiserStatusApi.getBrokerHealth()
    .then((response) => {
      const data = toPlain(response.data);
      dispatch(loadSuccess(data));
      return data;
    })
    .catch((error) => {
      dispatch(loadFailure(error));
      throw error;
    });
};
